module.exports = __webpack_public_path__ + "img/Main-Page-Trade-Still.533e6351.jpg";